import { IAddress } from "common/types";

import DrawerLayout from "client/common/components/stackables/DrawerLayout";
import { useCreateAddressMutation } from "client/accounts/hooks";
import { useCurrentDrawer } from "client/common/hooks/stackables";
import { useInvalidateSubscriptions } from "client/subscriptions/hooks/invalidate";

import AddressDrawerForm from "../forms/AddressDrawerForm";

const noop = () => undefined;

export type AddressUpdateDrawerProps = {
  address: IAddress;
  onSuccess?: (address: IAddress) => void;
};

const AddressUpdateDrawer = ({ address, onSuccess = noop }: AddressUpdateDrawerProps) => {
  const { close } = useCurrentDrawer();
  const invalidateSubscriptions = useInvalidateSubscriptions();

  const {
    mutate: updateAddress,
    isPending: isLoading,
    error,
  } = useCreateAddressMutation({
    onSuccess: (newAddress) => {
      invalidateSubscriptions();
      onSuccess(newAddress);
      close();
    },
  });

  return (
    <DrawerLayout>
      <DrawerLayout.Header title="Update address" onClose={close} />
      <AddressDrawerForm
        initialValues={{
          name: address.name,
          address_one: address.address_one,
          address_two: address.address_two,
          city: address.city,
          state: address.state,
          county: address.county,
          zipcode: address.zipcode,
          country: address.country,
        }}
        onSubmit={(values) =>
          updateAddress({
            ...values,
            replaces_address_id: address.id,
          })
        }
        isLoading={isLoading}
        submitError={error}
        submitText="Update address"
      />
    </DrawerLayout>
  );
};

export default AddressUpdateDrawer;
